import React from 'react'
import Icon from './Icon'

const AddCircle = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m28.4 21.6v-3.2h-6.8v-6.8h-3.2v6.8h-6.8v3.2h6.8v6.8h3.2v-6.8h6.8z m-8.4-18.2c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z" />
    </g>
  </Icon>
)

export default AddCircle



// WEBPACK FOOTER //
// ./icons/AddCircle.js